import {Fragment} from "react";
import {Box} from "@mui/system";
import AddCustomFieldForm from "./AddCustomFieldForm";

export default function AddCustomFieldContent({customFields, msgDataSourceId, handleClose, fetchCustomFieldsLoading}) {

    return (
        <Fragment>
            <Box sx={{mb: '20px'}}>
                <AddCustomFieldForm
                    customFields={customFields}
                    msgDataSourceId={msgDataSourceId}
                    handleClose={handleClose}
                    fetchCustomFieldsLoading={fetchCustomFieldsLoading}
                />
            </Box>
        </Fragment>
    );
}